import { Chapter, FadeUp } from "@/components/Reveal";
import { useLanguage } from "@/i18n/LanguageContext";

export default function Coverage() {
  const { t } = useLanguage();

  return (
    <section className="py-24 md:py-32" data-testid="coverage-section">
      <div className="mx-auto max-w-[1440px] px-6 md:px-12">
        <Chapter number="10" title={t("chapters.coverage")} />
        <div className="grid grid-cols-1 gap-14 lg:grid-cols-12 lg:gap-8">
          <FadeUp className="lg:col-span-6">
            <h2 className="text-balance font-syne text-3xl font-bold leading-[1.12] tracking-tight sm:text-4xl lg:text-[3rem]" data-testid="coverage-heading">
              {t("coverage.headingA")} <span className="text-[#F97316]">{t("coverage.headingB")}</span>
            </h2>
            <p className="mt-7 max-w-md text-sm leading-relaxed text-white/55 md:text-base">{t("coverage.text")}</p>
          </FadeUp>
          <div className="lg:col-span-6">
            <FadeUp>
              <p className="mb-6 font-spacemono text-[10px] uppercase tracking-[0.3em] text-white/35">
                {t("coverage.headOffice")}
              </p>
            </FadeUp>
            <div className="grid grid-cols-2 gap-x-8 sm:grid-cols-3" data-testid="coverage-areas">
              {t("coverage.areas").map((a, i) => (
                <FadeUp key={a} delay={i * 0.05}>
                  <div className="group flex items-center gap-3 border-t border-white/10 py-4" data-testid={`coverage-area-${i + 1}`}>
                    <span className="h-1 w-1 shrink-0 bg-[#F97316]" />
                    <span className="font-syne text-sm font-bold uppercase tracking-wide text-white/80 transition-colors duration-300 group-hover:text-[#F97316] md:text-base">
                      {a}
                    </span>
                  </div>
                </FadeUp>
              ))}
            </div>
            <FadeUp delay={0.3} className="mt-6">
              <p className="font-spacemono text-[10px] uppercase tracking-[0.25em] text-[#F97316]/70">
                {t("coverage.nationwide")}
              </p>
            </FadeUp>
          </div>
        </div>
      </div>
    </section>
  );
}
